import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { t } from '../../../../modules/infra/i18n';

import { canUserAddBankAccounts } from '../../../common/helpers/users';
import { getInstantPayoutIsFetching, getTotalBalance, getShouldShowDebitCard } from '../selectors';
import AddBarberPrefix from '../../../common/RoleAwareLink';
import Money from '../../../common/money';
import SingleBankAccount from './singleBankAccount';
import withPermissions from '../../../auth/utils/withPermissions';
import ShowCard from '../paymentCard/containers/showCard';
import DebitCard from '../debitCard';
import Invoices from '../subscription/components/Invoices';

const NoBankAccount = () => (
  <div className="o-flexbox">
    <div className="o-flexbox__item">
      <h4>{t('settings:bank_account.no_bank_account')}</h4>
    </div>
  </div>
);

class BankAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bankAccount: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    this.fetchAccount();
  }

  fetchAccount() {
    this.props.fetchAccount().then(() =>
      this.setState({
        isLoading: false,
      })
    );
    this.props.fetchDebitCard();
    this.props.fetchBalance();
  }

  render() {
    if (this.state.isLoading) return null;
    const { bankAccount, permissions, debitCard, total, shouldShowDebitCard } = this.props;

    return (
      <div className="c-wrapper">
        <div className="u-max-width-710 u-margin-auto u-mv-">
          <div className="c-heading c-heading--small">{t('settings:bank_account.payment_info')}</div>
        </div>
        <div className="c-inner-wrapper u-max-width-710 u-mt-">
          <NoBankAccount display-if={!bankAccount} />
          <SingleBankAccount display-if={bankAccount} account={bankAccount} deleteAccount={this.props.deleteAccount} />
          <div className="u-text-right" display-if={canUserAddBankAccounts(permissions) && !bankAccount}>
            <AddBarberPrefix className="c-btn" to="/settings/bank-account/add">
              {t('settings:bank_account.add_bank_account')}
            </AddBarberPrefix>
          </div>
        </div>
        <DebitCard display-if={shouldShowDebitCard && bankAccount} card={debitCard} />
        <div className="c-inner-wrapper u-max-width-710 u-mt-" display-if={shouldShowDebitCard && debitCard}>
          <div>
            {t('settings:bank_account.available_balance')}
            <br />
            <Money>{total}</Money>
          </div>
        </div>
        <div className="c-inner-wrapper u-max-width-710 u-mt-">
          <ShowCard />
        </div>
        <div className="c-inner-wrapper u-max-width-710 u-mt-">
          <Invoices />
        </div>
      </div>
    );
  }
}

BankAccount.propTypes = {
  fetchAccount: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  bankAccount: PropTypes.object,
  debitCard: PropTypes.object,
  fetchDebitCard: PropTypes.func,
  total: PropTypes.number,
  fetchBalance: PropTypes.func,
  shouldShowDebitCard: PropTypes.bool.isRequired,
};
BankAccount.defaultProps = {
  bankAccount: null,
  debitCard: null,
  fetchDebitCard: () => {},
  total: 0,
  initiateInstantPayout: () => {},
  fetchBalance: () => {},
};

const mapStateToProps = (state) => ({
  bankAccount: state.settings.bankAccount,
  debitCard: state.settings.debitCard,
  total: getTotalBalance(state),
  instantPayoutIsFetching: getInstantPayoutIsFetching(state),
  shouldShowDebitCard: getShouldShowDebitCard(state),
});

export default connect(mapStateToProps)(withPermissions(BankAccount));
